<template>
	<frontend-layout>
		<Head>
			<title>{{ $t("newsList.detail") }} - {{ $t("siteTitle") }}</title>
		</Head>

		<template #breadcrumb>
			<div class="pageInfo mb-2 p-1">
				<div class="page-breadcrumb float-sm-right">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/'"
								:class="{
									active: $page.url === '/',
								}">
								{{ $t("home") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/announcements'"
								:class="{
									active:
										$page.url ===
										`/announcements/${detail.id}`,
								}">
								{{ $t("announcements") }}
							</InertiaLink>
						</li>
						<li
							v-if="
								$i18n.locale == 'zh-TW' ||
								detail.title_en === ''
							"
							class="breadcrumb-item">
							{{ detail.title }}
						</li>
						<li v-else class="breadcrumb-item">
							{{ detail.title_en }}
						</li>
					</ol>
				</div>
			</div>
		</template>
		<div class="announcement">
			<h1>{{ $t("announcements") }}</h1>
			<div class="row">&nbsp;</div>
		</div>
		<section>
			<div class="content-box" v-if="detail.title">
				<h2 v-if="$i18n.locale == 'zh-TW' || detail.title_en === ''">
					{{ detail.title }}
				</h2>
				<h2 v-else>
					{{ detail.title_en }}
				</h2>
				<p class="subtitle">
					{{ $t("docs.publishedDate") }}:&nbsp;{{
						timeFormat(detail.published_at)
					}}
				</p>
				<hr />
				<p
					v-if="$i18n.locale == 'zh-TW' || detail.content_en === ''"
					v-html="detail.content"></p>
				<p v-else v-html="detail.content"></p>
				<div v-if="detail.files.length != 0">
					<hr />
					<h5>{{ $t("docs.attachments") }}</h5>
					<a
						v-for="link in detail.files"
						:key="link.id"
						class="attachment"
						:href="link"
						target="_blank">
						<span class="ts-icon is-download-icon"></span>
						&nbsp;&nbsp;{{ getFileName(link) }}
					</a>
				</div>
				<div v-if="detail.link">
					<hr />
					<h5>{{ $t("docs.links") }}</h5>
					<a class="attachment" :href="detail.link" target="_blank">
						<span class="ts-icon is-link-icon"></span>
						&nbsp;&nbsp;
						{{ detail.link }}
					</a>
				</div>
				<div class="subdetail">
					{{ $t("docs.lastUpdate") }}:&nbsp;{{
						timeFormat(detail.updated_at)
					}}&nbsp;&nbsp;&nbsp;
					<span class="ts-icon is-male-icon"></span>
					&nbsp;{{ detail.creator }}
				</div>
			</div>
			<div class="box-bottom">
				<InertiaLink
					v-if="previous != 0"
					class="box-bottom-item"
					:href="'/announcements/' + previous">
					<span class="ts-icon is-angle-left-icon"></span>
					&nbsp;前一則
				</InertiaLink>
				<div class="box-bottom-item pad">&nbsp;</div>
				<InertiaLink
					class="box-bottom-item middle"
					href="/announcements/"
					>{{ $t("docs.backList") }}</InertiaLink
				>
				<div class="box-bottom-item pad">&nbsp;</div>
				<InertiaLink
					v-if="next != 0"
					class="box-bottom-item next"
					:href="'/announcements/' + next">
					{{ $t("docs.next") }}&nbsp;
					<span class="ts-icon is-angle-right-icon"></span>
				</InertiaLink>
			</div>
		</section>
	</frontend-layout>
</template>

<script>
// import moment from 'moment';
import FrontendLayout from "@/Frontend/Shared/Layout";

export default {
	name: "detail",
	props: {
		id: String,
	},
	data() {
		return {
			detail: [],
			previous: 0,
			next: 0,
		};
	},
	methods: {
		timeFormat(time) {
			return time.split(" ")[0].replaceAll("-", "/");
		},
		getDetail() {
			var vm = this;
			axios
				.get("/api/v1/lists")
				.then(function (response) {
					var lists = response.data.announcements;

					var index = lists.findIndex((item) => item.id == vm.id);
					if (index >= 0) {
						vm.detail = lists[index];
					} else {
						vm.$inertia.visit("/404", { method: "get" });
					}
					if (index > 0) vm.previous = lists[index - 1].id;
					if (index + 1 < lists.length) vm.next = lists[index + 1].id;
				})
				.catch(function (error) {});
		},
		getFileName(url) {
			const lastSegment = url.split("/").pop();
			return lastSegment;
		},
	},
	created: function () {
		this.getDetail();
	},
	mounted() {},
	components: {
		FrontendLayout,
	},
};
</script>

<style scoped>
.announcement {
	text-align: center;
}
.content-box {
	position: relative;
	margin-left: auto;
	margin-right: auto;
	max-width: 950px;
	width: 70%;
	background-color: #ffff;
	padding: 45px 45px 20px 45px;
	box-shadow: #9d9d9d 0px 0px 7px 0px;
	border-radius: 1px;
	margin-bottom: 10px;
}
.content-box h2 {
	font-family: "Poppins", sans-serif;
	margin-bottom: 18px;
	color: #3e3f47;
}

.content-box h5 {
	color: #3e3f47;
	font-family: "Poppins", sans-serif;
}
.subtitle {
	color: grey;
	line-height: 0px;
}
.subdetail {
	width: 100%;
	color: grey;
	line-height: 0px;
	text-align: right;
}
.attachment {
	text-decoration: none;
	display: block;
	color: #3d4a63;
}
.attachment:hover {
	color: #0a7a7f;
}
.box-bottom {
	position: relative;
	margin-left: auto;
	margin-right: auto;
	max-width: 950px;
	width: 70%;
	margin-bottom: 10rem;
}

.box-bottom-item {
	display: inline-block;
	text-decoration: none;
	width: 8%;
	color: grey;
}

.middle {
	text-align: center;
}
.pad {
	width: 38%;
}

.middle {
	text-align: center;
}
.pad {
	width: 38%;
}

.next {
	text-align: right;
}
</style>
